import React from "react";
import styled from "styled-components";

const Mark = styled.span`
  position: relative;
  border: 1px solid ${(props) => props.theme.color.pink};
  width: 22px;
  height: 22px;
  left: 0;
  margin-right: 14px;
  vertical-align: middle;
  &::after {
    content: "✓";
    font-size: 20px;
    font-family: ${(props) => props.theme.font.montserrat};
    color: ${(props) => props.theme.color.pink};
    font-weight: bold;
    display: block;
    width: 0;
    height: 0;
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
  }
`;

const Input = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;
  &:checked + ${Mark} {
    &::after {
      width: 22px;
      height: 22px;
      opacity: 1;
      left: 3px;
      top: 0px;
      display: flex;
      align-items: center;
    }
  }
`;

const Label = styled.label`
  font-size: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px 5px 0;
  position: relative;
  ${(props: any) =>
    props.disabled &&
    `
        cursor: not-allowed;
        opacity: 0.4;
    `}
`;

interface RadioButtonProps {
  name: string;
  children: React.ReactNode;
  value: string;
  forwardRef: any;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  children,
  value,
  forwardRef,
}) => (
  <Label>
    <Input
      name={name}
      value={value}
      type="radio"
      ref={forwardRef({ required: true })}
    />
    <Mark />
    {children}
  </Label>
);
